import type { StatusTone } from "@care-by-ella/ui-tokens";

export type { StatusTone };

// TES-1037 — the one place a status tone becomes colour. Emelie:
// "Saknat underlag ska alltså inte använda exakt samma färg som en klinisk riskflagga."
// The classes are written out in full so Tailwind's scanner finds them.
//
// Pure (no React), so `node --test` can run it.
export const STATUS_TONE_CLASS: Record<StatusTone, string> = {
  risk: "bg-status-risk-fill text-status-risk-ink",
  missing: "bg-status-missing-fill text-status-missing-ink",
  incomplete: "bg-status-incomplete-fill text-status-incomplete-ink",
  complete: "bg-status-complete-fill text-status-complete-ink",
  neutral: "bg-status-neutral-fill text-status-neutral-ink",
};
